import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TermsOfUse from "../pages/TermsOfUse";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import SSIAnalysisPage from "../pages/ssi-analysis/page";
import AlmaDemandPage from "../pages/alma-demand/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/analisar-ssi",
    element: <SSIAnalysisPage />,
  },
  {
    path: "/alma-demand",
    element: <AlmaDemandPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
